// Typography tokens — lifted from the Parental Control Figma UI kit.
// Font: Poppins. Type scale below feeds UnoCSS shortcuts + Naive UI fontFamily.

export const fontFamily = {
  sans: "Poppins, system-ui, -apple-system, sans-serif", // headings + body
  ui: "Manrope, system-ui, -apple-system, sans-serif", // buttons + controls
  mono: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace", // inline code
} as const

export const typography = {
  // name: [font-size, font-weight, line-height]
  sectionTitle: { size: "1.5rem", weight: 600, leading: "1.3" }, // 24px SemiBold
  sectionInnerTitle: { size: "1rem", weight: 600, leading: "1.3" }, // 16px SemiBold
  body: { size: "0.875rem", weight: 400, leading: "1.5" }, // 14px Regular
  oneLiner: { size: "0.875rem", weight: 400, leading: "16px" }, // 14px Regular, 16 lh
  // Long-form document scale (legal pages) — larger and airier than the app
  // scale so a page of running prose stays readable. See decisions-log 2026-09-18.
  docTitle: { size: "1.875rem", weight: 700, leading: "1.25" }, // 30px Bold
  docSection: { size: "1.25rem", weight: 700, leading: "1.3" }, // 20px Bold
  docSubsection: { size: "1rem", weight: 700, leading: "1.35" }, // 16px Bold
  docBody: { size: "1rem", weight: 400, leading: "1.65" }, // 16px Regular
  docCode: { size: "0.85em", weight: 400, leading: "1.5" }, // inline code, relative to its line
} as const

export type Typography = typeof typography
